import * as React from 'react';
import { setPath } from './init/setPath';
import { validateIFrame } from '@ane/core/lib/host/Host.utilities';
import Logger from '@ane/core/lib/services/logging/Logger';
import { Loading } from '@ane/ui-components/lib/components/Loading';
import { AsyncRequestStatus } from '@ane/core/lib/models';
import { PLTTelemetryEventNames } from '@ane/exp-data/lib/telemetry/PLTTelemetryEventNames';
import { AppInit } from '@ane/exp-ux/lib/components/AppInit';
import store from './store/Store';
/**
 * TODO revisit
 * Hack to re implement ReactInterceptorsTypes
 */
import './main.types';

/**
 * Needed to ensure that setPath defines __webpack_public_path__
 * before the app is loaded and static assets load properly
 */
const Shell = React.lazy(() => import(/* webpackChunkName: "shell" */ './app'));

/**
 * ExPUI Host
 * Are we trying to load ExP in an iFrame, is this supported?
 * Use Case: we cannot host ExP in an iFrame from another domain
 */
validateIFrame();

const main = async () => {
  Logger.trackMetric({
    name: PLTTelemetryEventNames.PLT_Loader_main,
    average: performance.now(),
    properties: {
      url: document.location.href,
    },
  });
  await setPath('App', true);
  Logger.trackMetric({
    name: PLTTelemetryEventNames.PLT_Loader_main_setPath,
    average: performance.now(),
    properties: {
      url: document.location.href,
    },
  });
  const app = new AppInit({
    store,
    children: (
      <React.Suspense fallback={<Loading useProgressIndicator status={AsyncRequestStatus.Pending} data={null} />}>
        <Shell />
      </React.Suspense>
    ),
  });
  app.start();
};

main();
